import React from "react";
import ReviewProcessFormContainer from "./ReviewProcessFormContainer";

const AssignTicket = () => {
  // Example parameter to pass to ReviewProcessFormContainer

  return (
    <div className="my-10">
      <div>
        {/* Pass the ticketId as a prop to ReviewProcessFormContainer */}
        <ReviewProcessFormContainer lock='Y' />
      </div>
    </div>
  );
};

export default AssignTicket;
